export default "__VITE_ASSET__TEpGVOb$__"